import { useState, useEffect } from "react";
import "./style.css";

const PIN_OPTIONS = [
  {
    value: "24h",
    label: "24 hours",
    hint: "Keep it pinned for 1 day.",
    tone: "pink",
    icon: "clock",
  },
  {
    value: "7d",
    label: "7 days",
    hint: "Keep it pinned for 1 week.",
    tone: "blue",
    icon: "calendar",
  },
  {
    value: "30d",
    label: "30 days",
    hint: "Keep it pinned for 1 month.",
    tone: "red",
    icon: "calendar",
  },
];

const ClockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="8.25" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 8v4.2l2.6 1.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="4" y="5.5" width="16" height="14" rx="2.4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 4v3.2M16 4v3.2M4 10h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const PinGlyph = ({ className = "" }) => (
  <span className={`pin_glyph ${className}`.trim()} aria-hidden="true">📌</span>
);

export default function PinDurationModal({
  isVisible,
  onClose,
  onConfirm,
  isSubmitting = false,
}) {
  const [selectedDuration, setSelectedDuration] = useState("7d");

  useEffect(() => {
    if (isVisible) {
      setSelectedDuration("7d");
    }
  }, [isVisible]);

  if (!isVisible) return null;

  const handleConfirm = () => {
    if (isSubmitting) return;
    onConfirm(selectedDuration);
  };

  return (
    <div className="pin_duration_modal_overlay" onClick={onClose}>
      <div
        className="pin_duration_modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pin_duration_title"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="pin_modal_close" onClick={onClose} type="button" aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>

        <div className="pin_modal_hero">
          <span className="pin_modal_hero_circle">
            <PinGlyph />
          </span>
          <h3 id="pin_duration_title">Pin message</h3>
          <p className="pin_description">
            Choose how long this message should stay pinned in this chat.
          </p>
        </div>

        <div className="pin_options">
          {PIN_OPTIONS.map((option) => (
            <label
              key={option.value}
              className={`pin_option pin_option_${option.tone} ${selectedDuration === option.value ? "selected" : ""}`}
            >
              <span className={`pin_option_icon pin_option_icon_${option.tone}`}>
                {option.icon === "clock" ? <ClockIcon /> : <CalendarIcon />}
              </span>
              <span className="pin_option_copy">
                <span className="pin_option_label">{option.label}</span>
                <span className="pin_option_hint">{option.hint}</span>
              </span>
              <input
                type="radio"
                name="pinDuration"
                value={option.value}
                checked={selectedDuration === option.value}
                onChange={(e) => setSelectedDuration(e.target.value)}
              />
              <span className="pin_option_radio" aria-hidden="true" />
            </label>
          ))}
        </div>

        <div className="pin_duration_actions">
          <button className="cancel_btn" type="button" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button className="pin_btn" type="button" onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? "Pinning..." : "Pin"}
          </button>
        </div>
      </div>
    </div>
  );
}
